import { useState, useEffect } from 'react'

import gSession from '../script/session';
import gUtilities from '../script/utilities';
import TableWidget from './TableWidget';
import gEventRouter from "../script/event_router";
import gDataStore from "../script/data_store";

const k_job_collection = "dcs_job";

const JobPage = (props) => {
    const [job_table, setJobTable] = useState(null);
    const [job_list, setJobList] = useState([]);
    const [current, setCurrent] = useState(null);

    if (!current) {
        let selected = gDataStore.retrieve("CurrentJob", null);

        if (selected) {
            setCurrent(selected);
        }
    }

    async function setCurrentJob(job_id) {
        let request = {
            service: "db.query",
            collection: k_job_collection,
            many: false,
            query: {
                job_id: job_id
            },
            projection: {
                _id: 0,    // NOTE: only _id can be 0 if others are 1
                jversion: 1,
                job_id: 1,
                timestamp: 1,
                state: 1,
                progress: 1,
                converged: 1,
                duration_min: 1,
                tag: 1,
                machine_name: 1,
                simulator_name: 1,
                "plan.plan_name": 1,
                "plan.nbeams": 1
            }
        };

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("Job fetch filed", response.message);
            return;
        }

        console.log("DEBUG: [job.page] setCurrentJob", response);

        adjustJob(response);

        gDataStore.store("CurrentJob", response);
    }

    function adjustJob(job) {
        job.plan_name = job.plan.plan_name;
        job.nbeams = job.plan.nbeams;
        delete job.plan;
    }

    async function onSelect(job) {
        let record;
        if (job && job.job_id && job_table[job.job_id]) {
            record = job_table[job.job_id];
            setCurrent(record);

            console.log("DEBUG: [job.page] onSelect", job);
            await setCurrentJob(job.job_id);
        } else {
            gDataStore.store("CurrentJob", null);
        }
    }

    function onPlan(job) {
        gEventRouter.invoke("PlanDialog.showModal", job);
    }

    function onDetails(job) {
        console.log("DEBUG: [job.page] onDetails", job);
        gEventRouter.invoke("JobDialog.showModal", job);
    }

    function onWatch(job) {
        gEventRouter.invoke("JobWatchDialog.showModal", job);
    }

    function detailsButtonStyle(button, job) {
        let style = {
            visiblity: "visible"
        };

        return style;
    }

    function watchButtonStyle(button, job) {
        let style = {
            visiblity: "visible"
        };

        return style;
    }

    let buttons = [
        {
            label: "Details",
            callback: onDetails,
            style: detailsButtonStyle
        },
        {
            label: "Plan",
            callback: onPlan
        },
        {
            label: "Watch",
            callback: onWatch,
            style: watchButtonStyle
        }
    ];

    async function update() {
        let request = {
            collection: k_job_collection,
            service: "db.query",
            many: true,
            query: {},
            projection: {
                _id: 0,    // NOTE: only _id can be 0 if others are 1
                jversion: 1,
                job_id: 1,
                timestamp: 1,
                state: 1,
                progress: 1,
                converged: 1,
                duration_min: 1,
                tag: 1,
                machine_name: 1,
                simulator_name: 1,
                "plan.plan_name": 1,
                "plan.nbeams": 1
            }
        };

        let response = await gSession.exchange(request);

        if (!isMounted()) {
            return;
        }

        if (response.isError) {
            gUtilities.showError("Job List Update", response.message);
            return;
        }

        let map = {};
        for (let record of response.list) {
            adjustJob(record);
            record.fingerprint = gUtilities.fingerprint(record.job_id);
            record.date = record.timestamp.substring(5, 16);
            map[record.job_id] = record;
        }
        setJobTable(map);

        // latest datetime at top of table
        let sorted = response.list.sort((l, r) => {
            if (l.timestamp < r.timestamp) {
                return 1;
            } else if (l.timestamp > r.timestamp) {
                return -1;
            }

            return 0;
        });

        setJobList(sorted);
    }

    const columns = [
        "plan_name",
        "state",
        "progress",
        "duration_min",
        "machine_name",
        "date",
        "fingerprint"
    ];

    const titles = [
        "Plan",
        "State",
        "Progress (%)",
        "Time (m)",
        "Machine",
        "Date",
        "Fingerprint"
    ];

    function scheduleUpdate() {
        let id = setTimeout(() => {
            try {
                update();
            } catch (ex) {
                console.log("ERROR: [EXCEPTION] jobs update - ", ex);
            }
        }, 500);

        return id;
    }

    function rowClass(job) {
        if (current && current.job_id === job.job_id) {
            return "table-success";
        }

        return "table-info";
    }

    // detect existance of this page's root <div>
    function isMounted() {
        return gUtilities.isMounted("w_JobPageRootDiv");
    }

    useEffect(() => {
        let timer_id = scheduleUpdate();

        // cleanup function: stop updates.
        return () => {
            clearTimeout(timer_id);
        };
    }, [job_list]);

    return (
        <div id="w_JobPageRootDiv">
            <TableWidget name="Jobs" data={job_list} columns={columns} titles={titles} buttons={buttons} rowClassFunction={rowClass} rowSelectCallback={onSelect} />
        </div>
    );
}

export default JobPage;